"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var codegen_1 = require("./codegen");
var utils_1 = require("../utils");
var Typescript = /** @class */ (function (_super) {
    __extends(Typescript, _super);
    function Typescript() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Typescript.prototype.generate = function (s, ir) {
        return [
            ir.documentationComment,
            "export " + ir.prefix + " " + this.getSafeTitle(s.title),
            ir.prefix === "type" ? " = " : " ",
            ir.typing,
            ir.prefix === "type" ? ";" : "",
        ].join("");
    };
    Typescript.prototype.handleBoolean = function (s) {
        var typing = "boolean";
        if (s.const) {
            typing = s.const;
        }
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: typing };
    };
    Typescript.prototype.handleNull = function (s) {
        return { prefix: "type", typing: "null", documentationComment: this.buildDocs(s) };
    };
    Typescript.prototype.handleNumber = function (s) {
        var typing = "number";
        if (s.const) {
            typing = s.const;
        }
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: typing };
    };
    Typescript.prototype.handleInteger = function (s) {
        return this.handleNumber(s);
    };
    Typescript.prototype.handleNumericalEnum = function (s) {
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: this.buildEnum(s),
        };
    };
    Typescript.prototype.handleString = function (s) {
        var typing = "string";
        if (s.const) {
            typing = "\"" + s.const + "\"";
        }
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: typing };
    };
    Typescript.prototype.handleStringEnum = function (s) {
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: this.buildEnum(s),
        };
    };
    Typescript.prototype.handleOrderedArray = function (s) {
        var typing = "[" + this.getJoinedSafeTitles(s.items) + "]";
        if (s.const) {
            typing = s.const;
        }
        var prefix = "type";
        return { documentationComment: this.buildDocs(s), typing: typing, prefix: prefix };
    };
    Typescript.prototype.handleUnorderedArray = function (s) {
        var typing = this.getSafeTitle(this.refToTitle(s.items)) + "[]";
        if (s.const) {
            typing = s.const;
        }
        var prefix = "type";
        return { documentationComment: this.buildDocs(s), prefix: prefix, typing: typing };
    };
    Typescript.prototype.handleUntypedArray = function (s) {
        var typing = "any[]";
        var prefix = "type";
        return { documentationComment: this.buildDocs(s), prefix: prefix, typing: typing };
    };
    Typescript.prototype.handleObject = function (s) {
        var _this = this;
        var ir = {
            documentationComment: this.buildDocs(s),
        };
        if (s.const) {
            ir.typing = s.const;
            ir.prefix = "type";
            return ir;
        }
        var sProps = s.properties;
        var propertyTypings = Object.keys(sProps).reduce(function (typings, key) {
            var propSchema = sProps[key];
            var isRequired = false;
            if (s.required) {
                isRequired = s.required.indexOf(key) !== -1;
            }
            var title = _this.getSafeTitle(_this.refToTitle(propSchema));
            return __spreadArray(__spreadArray([], typings), ["  " + key + (isRequired ? "" : "?") + ": " + title + ";"]);
        }, []);
        if (s.patternProperties !== undefined) {
            var subTypes_1 = [];
            Object.values(s.patternProperties).forEach(function (prop) {
                var title = _this.getSafeTitle(_this.refToTitle(prop));
                if (subTypes_1.includes(title) === false) {
                    subTypes_1.push(title);
                }
            });
            propertyTypings.push("  [regex: string]: " + subTypes_1.join(" | ") + " | any;");
        }
        else if (s.additionalProperties !== false) {
            propertyTypings.push("  [k: string]: any;");
        }
        ir.prefix = "interface";
        ir.typing = __spreadArray(__spreadArray(["{"], propertyTypings), ["}"]).join("\n");
        return ir;
    };
    Typescript.prototype.handleUntypedObject = function (s) {
        return {
            prefix: "interface",
            typing: "{ [key: string]: any; }",
            documentationComment: this.buildDocs(s),
        };
    };
    Typescript.prototype.handleAnyOf = function (s) {
        var sAny = s.anyOf;
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: this.getJoinedSafeTitles(sAny, " | "),
        };
    };
    Typescript.prototype.handleAllOf = function (s) {
        var sAll = s.allOf;
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: this.getJoinedSafeTitles(sAll, " & "),
        };
    };
    Typescript.prototype.handleOneOf = function (s) {
        var sOne = s.oneOf;
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: this.getJoinedSafeTitles(sOne, " | "),
        };
    };
    Typescript.prototype.handleConstantBool = function (s) {
        return {
            typing: "type " + utils_1.getTitle(s) + " = any;",
        };
    };
    Typescript.prototype.handleUntyped = function (s) {
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: "any" };
    };
    Typescript.prototype.buildEnum = function (schema) {
        var typeOf = schema.type === "string" ? "string" : "number";
        var sEnum = schema.enum;
        return sEnum
            .filter(function (s) { return typeof s === typeOf; })
            .map(function (s) { return typeOf === "string" ? "\"" + s + "\"" : s; })
            .join(" | ");
    };
    Typescript.prototype.buildDocs = function (s) {
        var docStringLines = [];
        if (s.description) {
            docStringLines.push(" * " + s.description);
            docStringLines.push(" *");
        }
        if (s.default) {
            var def = s.default;
            var defAsStr = "" + def;
            if (def instanceof Array || (typeof def === "object" && def !== null)) {
                defAsStr = JSON.stringify(def);
            }
            docStringLines.push(" * @default " + defAsStr);
            docStringLines.push(" *");
        }
        if (s.examples) {
            s.examples.forEach(function (example) {
                docStringLines.push(" * @example");
                docStringLines.push(" * `" + example + "`");
                docStringLines.push(" *");
            });
        }
        if (docStringLines.length > 0) {
            return __spreadArray(__spreadArray([
                "/**",
                " *"
            ], docStringLines), [
                " */",
                "",
            ]).join("\n");
        }
    };
    return Typescript;
}(codegen_1.CodeGen));
exports.default = Typescript;
